import React from "react";

const Button = ({ toggleTheme, theme }) => {
  return (
    <button
      type="button"
      className={`${theme === "light-theme" ? "light" : ""} btn`}
      onClick={toggleTheme}
    >
      <span className={`${theme === "dark-theme" ? "dark" : ""} circle`}></span>
    </button>
  );
};

export default Button;
